import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { useLocationId } from '@/data/useLocationId';
import { formsApi } from '../api/formsApi';

export interface UseFormAssignmentsParams {
  status?: string;
  q?: string;
  enabled?: boolean;
}

/** `GET /api/forms/assignments` — the location-scoped assignment list with the full consent-ledger timeline. */
export function useFormAssignments(params?: UseFormAssignmentsParams) {
  const locationId = useLocationId();
  const enabled = (params?.enabled ?? true) && locationId != null;
  return useQuery({
    queryKey: keys.forms.assignments(locationId ?? 0, params?.status, params?.q),
    queryFn: ({ signal }) =>
      formsApi.getAssignments(
        {
          ...(locationId != null ? { locationId } : {}),
          ...(params?.status ? { status: params.status } : {}),
          ...(params?.q ? { q: params.q } : {}),
        },
        { signal },
      ),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? 30_000 : false,
  });
}
